// libs
import { useCallback } from 'react';

// defs
import { WidgetTrackingData } from 'shared/components/AdPlatformWidgets/types';

interface UseDwebOnClickArgs {
  url?: string;
  onWidgetClick: (trackingData: WidgetTrackingData) => void;
  trackingData?: WidgetTrackingData;
}

export const useDwebOnClick = ({ url, onWidgetClick, trackingData }: UseDwebOnClickArgs) => {
  const onClick: React.MouseEventHandler = useCallback(
    (e) => {
      if (!url) {
        return;
      }

      e.preventDefault();

      if (trackingData !== undefined) {
        onWidgetClick(trackingData);
      }

      window.open(url, '_blank', 'noopener');
    },
    [url, onWidgetClick, trackingData]
  );

  return { onClick };
};
